import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface AgentService {
  id: string;
  name: string;
  description: string | null;
  active: boolean;
}

export function useAgentServices(userId?: string) {
  return useQuery({
    queryKey: ["agent-services", userId],
    queryFn: async () => {
      if (!userId) return [];

      const { data, error } = await supabase
        .from("services")
        .select("id, name, description, active")
        .eq("assigned_agent_id", userId);

      if (error) throw error;
      return data as AgentService[];
    },
    enabled: !!userId,
  });
}
